import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
import { SetPaymentErrorsInput } from "../types/types";

const SET_PAYMENT_ERRORS_MUTATION = gql(`
mutation SetPaymentErrors($offerId: String!, $input: SetPaymentErrorsInput!) {
  setPaymentErrors(id: $offerId, input: $input)
}
`);

export function useSetPaymentErrors() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation(SET_PAYMENT_ERRORS_MUTATION);
  const setPaymentErrors = async (input: SetPaymentErrorsInput) => {
    if (!offerId) {
      throw new Error('Offer ID is required');
    }
    const { data } = await mutation({
      variables: { offerId, input },
    });
    return data;
  };
  return [setPaymentErrors, info] as const;
}
